(function () {
  'use strict';

  var body = document.body;
  var drawer = document.querySelector('[data-trx-menu]');
  var backdrop = document.querySelector('[data-trx-menu-backdrop]');
  var opener = document.querySelector('[data-trx-menu-open]');
  var closer = document.querySelector('[data-trx-menu-close]');
  var header = document.querySelector('.trx-header');

  function menuIsOpen() { return !!(drawer && drawer.classList.contains('is-open')); }
  function focusableInDrawer() {
    if (!drawer) return [];
    return Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (el) { return !el.hasAttribute('hidden'); });
  }
  function setMenu(open) {
    if (!drawer) return;
    var wasOpen = menuIsOpen();
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) drawer.removeAttribute('inert'); else drawer.setAttribute('inert', '');
    if (backdrop) { backdrop.hidden = !open; backdrop.classList.toggle('is-open', open); }
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.classList.toggle('trx-menu-open', open);
    if (open && closer) window.setTimeout(function () { closer.focus(); }, 30);
    else if (!open && wasOpen && opener) opener.focus();
  }

  if (drawer) drawer.setAttribute('inert', '');
  if (opener) opener.addEventListener('click', function () { setMenu(true); });
  if (closer) closer.addEventListener('click', function () { setMenu(false); });
  if (backdrop) backdrop.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (event) {
    if (!menuIsOpen()) return;
    if (event.key === 'Escape') { event.preventDefault(); setMenu(false); return; }
    if (event.key === 'Tab') {
      var items = focusableInDrawer();
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  document.querySelectorAll('[data-trx-menu] a').forEach(function (link) { link.addEventListener('click', function () { setMenu(false); }); });

  if (header) {
    var ticking = false;
    var syncHeader = function () { header.classList.toggle('is-scrolled', window.scrollY > 12); ticking = false; };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(syncHeader); } }, { passive: true });
    syncHeader();
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-trx-media]'), function (image) {
    var ready = function () { image.classList.remove('is-broken'); image.classList.add('is-ready'); };
    var broken = function () { image.classList.remove('is-ready'); image.classList.add('is-broken'); };
    image.addEventListener('load', ready); image.addEventListener('error', broken);
    if (image.complete) { if (image.naturalWidth > 0) ready(); else broken(); }
  });

  var revealNodes = Array.prototype.slice.call(document.querySelectorAll([
    '.template-index .trx-v6-hero__copy',
    '.template-index .trx-v6-hero__media',
    '.template-index .trx-v6-trust',
    '.template-index .trx-v6-shop__head',
    '.template-index .trx-v6-card',
    '.template-index .trx-v6-fit__inner',
    '.trx-collection__breadcrumb',
    '.trx-collection__head',
    '.trx-collection__tools',
    '.trx-productcard',
    '.trx-collection__empty',
    '.trx-pdp__gallery',
    '.trx-pdp__info',
    '.trx-related',
    '.trx-reviews__head',
    '.trx-reviews__published',
    '.trx-reviews__formwrap',
    '.trx-footer__main'
  ].join(',')));
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  revealNodes.forEach(function (el) { el.classList.add('trx-reveal'); });
  Array.prototype.forEach.call(document.querySelectorAll('.trx-v6-card, .trx-productcard'), function (el, index) { el.style.setProperty('--trx-delay', Math.min((index % 4) * 55, 165) + 'ms'); });
  if (!revealNodes.length || reducedMotion || !('IntersectionObserver' in window)) revealNodes.forEach(function (el) { el.classList.add('is-visible'); });
  else {
    var revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) { if (!entry.isIntersecting) return; entry.target.classList.add('is-visible'); observer.unobserve(entry.target); });
    }, { threshold: 0.06, rootMargin: '0px 0px -5% 0px' });
    revealNodes.forEach(function (el) { revealObserver.observe(el); });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-trx-qty], [data-qty-change]');
    if (!btn) return;
    var input = null, delta = 0;
    if (btn.hasAttribute('data-trx-qty')) {
      var control = btn.closest('.trx-qty');
      input = control ? control.querySelector('input[type="number"]') : null;
      delta = btn.getAttribute('data-trx-qty') === 'plus' ? 1 : -1;
    } else {
      var selector = btn.getAttribute('data-qty-change');
      input = selector ? document.querySelector(selector) : null;
      delta = parseInt(btn.getAttribute('data-qty-delta') || '0', 10);
    }
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var current = parseInt(input.value || '0', 10);
    input.value = Math.max(min, current + delta);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var productForm = document.querySelector('[data-trx-product-form]');
  var sticky = document.querySelector('[data-trx-sticky-atc]');
  var radios = productForm ? productForm.querySelectorAll('.trx-variant-radio') : [];
  var productPrice = document.querySelector('[data-trx-price]');
  var productAtc = productForm ? productForm.querySelector('[data-trx-atc]') : null;
  var stickyPrice = sticky ? sticky.querySelector('[data-trx-sticky-price]') : null;
  var stickyButton = sticky ? sticky.querySelector('[data-trx-sticky-submit]') : null;
  function currentVariantRadio() { return productForm ? productForm.querySelector('.trx-variant-radio:checked') : null; }
  function syncVariantUI(radio) {
    if (!radio) return;
    var price = radio.getAttribute('data-price') || '';
    var available = radio.getAttribute('data-available') === 'true';
    if (productPrice && price) productPrice.textContent = price;
    if (stickyPrice && price) stickyPrice.textContent = price;
    if (productAtc) { productAtc.disabled = !available; productAtc.textContent = available ? 'Add to Bag' : 'Unavailable'; }
    if (stickyButton) { stickyButton.disabled = !available; stickyButton.textContent = available ? 'Add to Bag' : 'Unavailable'; }
  }
  Array.prototype.forEach.call(radios, function (radio) { radio.addEventListener('change', function () { syncVariantUI(radio); }); });
  syncVariantUI(currentVariantRadio());

  if (sticky) sticky.setAttribute('inert', '');
  if (sticky && productForm && stickyButton) {
    stickyButton.addEventListener('click', function () {
      var radio = currentVariantRadio();
      if (radios.length && (!radio || radio.getAttribute('data-available') !== 'true')) return;
      if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit(); else productForm.submit();
    });
    if ('IntersectionObserver' in window) {
      var buy = productForm.querySelector('.trx-pdp__buy');
      if (buy) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
            if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
          });
        }, { threshold: 0.15 });
        observer.observe(buy);
      }
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-trx-form-success]'), function (success) {
    window.setTimeout(function () {
      if (typeof success.focus === 'function') {
        try { success.focus({ preventScroll: true }); } catch (error) { success.focus(); }
      }
      if (typeof success.scrollIntoView === 'function') success.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    }, 140);
  });

  Array.prototype.forEach.call(document.querySelectorAll('[data-trx-toast]'), function (toast) {
    toast.classList.add('is-visible');
    var close = toast.querySelector('[data-trx-toast-close]');
    var hide = function () { toast.classList.remove('is-visible'); };
    if (close) close.addEventListener('click', hide);
    window.setTimeout(hide, 7000);
  });

  Array.prototype.forEach.call(document.querySelectorAll('form .trx-btn[type="submit"][data-trx-submit]'), function (submit) {
    var form = submit.form;
    if (!form) return;
    form.addEventListener('submit', function () {
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
      submit.classList.add('is-loading');
      submit.setAttribute('aria-busy', 'true');
    });
  });
})();

/* =========================================================
   TAILROAD — MASTER POLISH v12
   Subtle pointer depth, press feedback and scroll progress.
   Progressive enhancement only; no commerce/business logic changes.
   ========================================================= */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var frame = null;

  root.classList.add('trx-master-ready');

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function syncProgress() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      var doc = document.documentElement;
      var max = Math.max(1, doc.scrollHeight - window.innerHeight);
      var progress = clamp(window.scrollY / max, 0, 1);
      root.style.setProperty('--trx-scroll-progress', progress.toFixed(4));
      frame = null;
    });
  }

  window.addEventListener('scroll', syncProgress, { passive: true });
  window.addEventListener('resize', syncProgress, { passive: true });
  syncProgress();

  if (!reduced && finePointer && !saveData) {
    var depthTargets = Array.prototype.slice.call(document.querySelectorAll([
      '.template-index .trx-v6-card',
      '.trx-productcard',
      '.trx-pdp__gallery',
      '.trx-reviews__formwrap',
      '.trx-policy__help'
    ].join(',')));

    depthTargets.forEach(function (card) {
      var moveFrame = null;
      var latestX = 0;
      var latestY = 0;
      card.setAttribute('data-trx-depth', '');

      function renderTilt() {
        var rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) { moveFrame = null; return; }
        var x = clamp((latestX - rect.left) / rect.width, 0, 1) - 0.5;
        var y = clamp((latestY - rect.top) / rect.height, 0, 1) - 0.5;
        card.style.setProperty('--trx-tilt-x', (-y * 1.8).toFixed(2) + 'deg');
        card.style.setProperty('--trx-tilt-y', (x * 1.8).toFixed(2) + 'deg');
        moveFrame = null;
      }

      card.addEventListener('pointerenter', function () {
        card.classList.add('is-trx-hovered');
      });
      card.addEventListener('pointermove', function (event) {
        latestX = event.clientX;
        latestY = event.clientY;
        if (!moveFrame) moveFrame = window.requestAnimationFrame(renderTilt);
      }, { passive: true });
      card.addEventListener('pointerleave', function () {
        card.classList.remove('is-trx-hovered');
        card.style.setProperty('--trx-tilt-x', '0deg');
        card.style.setProperty('--trx-tilt-y', '0deg');
      });
    });
  }

  var pressTargets = Array.prototype.slice.call(document.querySelectorAll('.trx-btn, [data-trx-atc], [data-trx-sticky-submit]'));
  pressTargets.forEach(function (control) {
    function press() {
      if (control.disabled || control.getAttribute('aria-disabled') === 'true') return;
      control.classList.add('is-trx-pressed');
    }
    function release() { control.classList.remove('is-trx-pressed'); }

    control.addEventListener('pointerdown', press);
    control.addEventListener('pointerup', release);
    control.addEventListener('pointercancel', release);
    control.addEventListener('pointerleave', release);
    control.addEventListener('blur', release);
    control.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') press();
    });
    control.addEventListener('keyup', function (event) {
      if (event.key === 'Enter' || event.key === ' ') release();
    });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      pressTargets.forEach(function (control) { control.classList.remove('is-trx-pressed'); });
    }
  });
})();
